import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class PollFormState {
  static createNewPoll() {
    const poll = app.store.createRecord('polls');
    poll.pushAttributes({
      question: '',
      endDate: '',
      publicPoll: false,
      allowMultipleVotes: false,
      hideVotes: false,
      allowChangeVote: false,
      maxVotes: 0
    });
    poll.tempOptions = [app.store.createRecord('poll_options'), app.store.createRecord('poll_options')];
    return poll;
  }
  constructor(poll) {
    _defineProperty(this, "poll", void 0);
    _defineProperty(this, "loading", void 0);
    _defineProperty(this, "deleting", void 0);
    _defineProperty(this, "expandedGroup", void 0);
    _defineProperty(this, "dirty", false);
    if (!poll) {
      poll = PollFormState.createNewPoll();
    }
    this.loading = false;
    this.deleting = false;
    this.poll = poll;
    this.expandedGroup = 'setup';
  }
  isNew() {
    return !this.poll.exists;
  }
  isDraft() {
    return this.poll.exists && this.poll.isDraft();
  }
  markDirty(value) {
    if (value === void 0) {
      value = true;
    }
    this.dirty = value;
  }
  isExpanded(groupKey) {
    return this.expandedGroup === groupKey;
  }
  expand(groupKey) {
    this.expandedGroup = groupKey;
    m.redraw();
  }
  async save(data) {
    this.loading = true;
    m.redraw();
    try {
      this.poll = await this.poll.save(data);
      /**
       * Cleanup attributes:
       * For the saving process, we add the options directly to the attributes.
       * As we currently cannot add new PollOptions as relationships.
       */
      delete this.poll.data.attributes.options;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async delete() {
    this.loading = true;
    m.redraw();
    try {
      await this.poll.delete();
      this.deleting = true;
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('fof-polls', 'forum/states/PollFormState', PollFormState);